import { DateInput } from '../helpers/DateComponent';
export { DateInput };
export const DateInputUser = DateInput;